// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/line-poncho.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-default {
  background: #f0f0f0;
  background: linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(240,240,240,1) 100%);
  box-shadow: 0 4px 7px -5px #777;
  color: #98a6ad !important;
}
.topbar .topbar-left {
  box-shadow: 0 4px 7px -5px #777;
  	    background-color: #FFFFFF !important;
	    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
    background-size: auto 3px !important;
    background-repeat: no-repeat !important;
    background-position: right bottom !important;
    padding: 10px 0 0 0 !important;
}

.button-menu-mobile {
    background-color: #000000;
    border: 1px solid #000000;  
}
.button-menu-mobile:hover {
    background-color: #4f4f4f;
    border: 1px solid #4f4f4f;  
}
.navbar-default .right-menu-item{
  color: #000;
}
.app-search .form-control, .app-search .form-control:focus {
  border: 1px solid rgba(212, 212, 212, 1);
  color: #000000 !important;
  background: #ffffff;
}
.app-search a {
  color: rgba(80, 80, 80, 0.7);
}

.logo img {
      margin-top: 2px !important;
      width: 169px;
    	height: auto;
}

.logo i {
        margin-top: 4px !important;
}
.user-box .dropdown-menu {
	left: auto !important;
    right: 0 !important;
 }



.app-search .form-control::placeholder {
  color: #98a6ad !important;
}
.app-search .form-control::-webkit-input-placeholder {
  color: #98a6ad !important;
}
.app-search .form-control::-moz-placeholder {
  color: #98a6ad !important;
}
.app-search .form-control:-ms-input-placeholder {
  color: #98a6ad !important;
}
.app-search .form-control:-moz-placeholder {
  color: #98a6ad !important;
}
.gmaps, .gmaps-panaroma {
  height: 700px;
}

.nav-tabs > li > a {
    font-size: 12px;
}
.content-tabs-ypf{
    border-top: none !important;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;

}
.badge {
    font-size: 12px;
}

.form-control-static {
  color: #015192;
  font-weight: 500;
  font-size: 13px;
}

label {
  font-size: 13px;
}

.badge-modal {
  position: absolute;
  right: 46px;
  top: 6px;
}
.navbar-default{
	    background-color: #FFFFFF !important;
	    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
	    background-size: 100% 3px !important;
	    background-repeat: no-repeat !important;
	    background-position: bottom !important;
}

.enlarged #wrapper .left.side-menu #sidebar-menu ul > li {
    white-space: normal !important;
}
/* CUSTOM IMG SIMULADOR */

.container-img{
  background-color:#FFFFFF;
  width: 100%;
  height: 450px;
  overflow: auto;
  position: relative;
}

#img-mapa {
  -webkit-transition: all .2s ease-in-out;
  -moz-transition: all .2s ease-in-out;
  -o-transition: all .2s ease-in-out;
  -ms-transition: all .2s ease-in-out;
  /*position: absolute;*/
  top: 0;
  left: 0;
  transform: scale(1);
  transform-origin: 0 0;
}

.container-plano {
    width: 100%; 
  	height: 450px;
  	overflow-y: scroll;
    overflow-x: scroll;  	
}

.masthead{
  background-color: #000000 !important;
}
.links{
  position: absolute;
  cursor: pointer;
  font-size: 10px;
  text-align: center;
  color: #FFFFFF;
  width: 75px;
  height: 75px;
  border-radius: 50%;
  background-color: rgba(255, 0, 0, 0.3);
  left: 240px;
  top: 126px;
}
.links.focused:after{
  position: absolute;
  top: -5px;
  height: calc(100% + 10px);
  left: -5px;
  width: calc(100% + 10px);
  /*border: 2px solid rgba(120, 0, 0, 0.7);*/
  content: '';
  display: block;
  border-radius: 50%;
}
.act{
  background-color: rgba(255, 0, 0, 0.7);
}
.shadow-prueba{
	  box-shadow: 3px 3px 3px #333;
	  border: 1px solid red;
}
#link-1{
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: rgba(255, 0, 0, 0.7);
  left: 262px;
  top: 152px;
}
#link-2{
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: rgba(127, 191, 63, 0.7);
  left: 163px;
  top: 150px;
}
.nav-zoom{
  background: #f0f0f0;
  background: linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(240,240,240,1) 100%);
  color: #000000;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.inner-zoom{
  width: 600px;

}

.logo-most{
  max-width: 270px;
}
.logo-ypf{
  max-width: 150px;
}
.cover-container{
  position: relative;
  padding-left: 0rem!important;
  padding-right: 0rem!important;
  padding-bottom: 0rem!important;
  padding-top: 0!important;
}

.modal-content{
  color: #0b2e13;
}

.modal table{
  font-size: 12px !important;
}
.f-10{
  font-size: 10px !important;
}
.f-11{
  font-size: 11px !important;
}
.f-12{
  font-size: 12px !important;
}
.f-13{
  font-size: 13px !important;
}
.f-14{
  font-size: 14px !important;
}
.f-16{
  font-size: 16px !important;
}

.modal-lg {
  max-width: 1024px !important;
}

#color-link1{
  color: transparent !important;
}

.margin-top-10{
	margin-top:10px !important;
}

#datatable_filter{
  float: right !important;
}
#datatable_filter label{
  margin-bottom: 0;
}
.dataTables_length {
  margin-top: 15px;
  margin-bottom: 0;
  padding-bottom: 0px;
}

.dataTables_length label{
  margin-bottom: 0;
}
.pagination{
  float: right;
}

.txt-header-modal{
  position: absolute;
  right: 15px;
  font-size: 12px;
  top: 20px;
  text-align: right;
}

.bg-light {
  background-color: #f3f3f3!important;
}

.tabs-bordered .nav-item .nav-link.active {
  border-bottom: 3px solid #78c350 !important;
  margin-bottom: -1px;
  color: #348cd4;
}
.card-heading {
  padding: 10px 20px;
}

.footer {
    padding: 7px 10px 6px;
        position: fixed;
}
#wrapper {
    overflow: initial !important;
}
.table {
    font-size: 13px;
}

.icono{
    font-size: 17px;
}

.page-title-box .page-title {
    margin-bottom: 5px;
    float: initial;
    font-size: 20px;
}

.page-title-box .breadcrumb {
    float: inherit;
}
.btn-custom {
    border: 1px solid #348cd4 !important;
}
.btn-custom:hover, .btn-custom:focus, .btn-custom:active, .btn-custom.active, .btn-custom.focus, .btn-custom:active, .btn-custom:focus, .btn-custom:hover, .open > .dropdown-toggle.btn-custom {
    border: 1px solid #348cd4 !important;
}

.col-acciones{
	width: 110px !important;
	text-align: center;
}

td a i{
	font-size: 18px !important;
}

.tab-content {
    padding: 12px 12px 12px 12px;
    border-bottom: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
    margin-bottom: 17px;
}
.obligatorio{
	color:#ff0000;
	font-size: 12px;
}
.text-obligatorio{
	color:#ff0000 !important;
}

.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    color: #ffffff !important;
}
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    background-color: #358cd4 !important;
}
.nav-tabs .nav-link {
    background-color: #f3f3f3 !important;
}

#modalCrearPregunta{
	background-color: rgba(0, 0, 0, 0.7) !important;
	padding-right: 30px !important;
}

#modalCrearDominio{
	background-color: rgba(0, 0, 0, 0.7) !important;
}

.cursor{
	cursor: pointer !important;
}

.disabledbutton {
	    pointer-events: none;
	    opacity: 0.4;
}

.accordion-poncho{
	background: #ffffff !important;
    border-radius: 20px !important;
        border: 1px solid #e2e2e2;
       
}

.collapse {
    border-bottom: 0 !important;
}

.headingAccordion{
    padding: 5px 5px 2px 5px;
    background-color: #348CD4;
    border-top-right-radius: 15px !important;
    border-top-left-radius: 15px !important;
}
.headingAccordion button{
margin-top: -34px;

}
.bg-amarillo{
	 background-color: #eed057 !important;
}
.bg-contratista {
  background-color: #00a5af !important;
}
.page-title-box {
    padding: 25px 20px 0px 25px;
}
.card{
	    border-radius: 1.25rem;
}

#map_dashboard{
	box-shadow: 0px 0px 13px 0px rgba(0,0,0,0.29);
}
.table-responsive {
	border-top:1px solid #cecece;
}

#datosintalacionestable_length{
    position: absolute !important;
    right: 7px !important;
    top: -11px !important;
}


#datosintalacionestable_wrapper > div:first-child {
    background-color: #f3f3f3;
    border-bottom: 1px #cecece solid;
        height: 39px;
}

 #datosintalacionestable {
    margin-bottom: -5px !important;
    border-bottom: 1px solid #cecece;
}


#datosintalacionestable_length{
	float: right;
}
#datosintalacionestable_wrapper{
	position:relative;
}

#datosintalacionestable_info{
    padding-top: 4px;
    white-space: normal;
    font-size: 12px;
    padding-right: 49px;
    line-height: 14px;
    color: #008fcf;
}

.nav-second-level.nav > li > a {
    padding-left: 46px !important;
    line-height: 15px;
}`, "",{"version":3,"sources":["webpack://./src/resources/css/custom-ypf.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EAMnB,uFAAuF;EAIvF,+BAA+B;EAC/B,yBAAyB;AAC3B;AACA;EAGE,+BAA+B;OAC1B,oCAAoC;KACtC,oEAA2D;IAC5D,oCAAoC;IACpC,uCAAuC;IACvC,4CAA4C;IAC5C,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;EACE,WAAW;AACb;AACA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;;AAEA;MACM,0BAA0B;MAC1B,YAAY;KACb,YAAY;AACjB;;AAEA;QACQ,0BAA0B;AAClC;AACA;CACC,qBAAqB;IAClB,mBAAmB;CACtB;;;;AAID;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;;AAEA;IACI,eAAe;AACnB;AACA;IACI,2BAA2B;IAC3B,oCAAoC;IACpC,qCAAqC;;AAEzC;AACA;IACI,eAAe;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;AACA;KACK,oCAAoC;KACpC,oEAA2D;KAC3D,oCAAoC;KACpC,uCAAuC;KACvC,sCAAsC;AAC3C;;AAEA;IACI,8BAA8B;AAClC;AACA,yBAAyB;;AAEzB;EACE,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,kCAAkC;EAClC,mCAAmC;EACnC,sBAAsB;EACtB,MAAM;EACN,OAAO;EACP,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;IACI,WAAW;GACZ,aAAa;GACb,kBAAkB;IACjB,kBAAkB;AACtB;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,UAAU;EACV,wBAAwB;EACxB,0CAA0C;EAC1C,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,sCAAsC;AACxC;AACA;GACG,4BAA4B;GAC5B,qBAAqB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,UAAU;AACZ;AACA;EACE,mBAAmB;EAMnB,uFAAuF;EACvF,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;;AAEd;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;;AAEA;IACI,qBAAqB;QACjB,eAAe;AACvB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;;AAEA;CACC,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;IACI,4BAA4B;IAC5B,gCAAgC;IAChC,8BAA8B;IAC9B,+BAA+B;IAC/B,mBAAmB;AACvB;AACA;CACC,aAAa;CACb,eAAe;AAChB;AACA;CACC,wBAAwB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;;AAEA;CACC,+CAA+C;CAC/C,8BAA8B;AAC/B;;AAEA;CACC,+CAA+C;AAChD;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;KACK,oBAAoB;KACpB,YAAY;AACjB;;AAEA;CACC,8BAA8B;IAC3B,8BAA8B;QAC1B,yBAAyB;;AAEjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,wCAAwC;IACxC,uCAAuC;AAC3C;AACA;AACA,iBAAiB;;AAEjB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;IACI,2BAA2B;AAC/B;AACA;KACK,sBAAsB;AAC3B;;AAEA;CAGC,6CAA6C;AAC9C;AACA;CACC,4BAA4B;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,qBAAqB;AACzB;;;AAGA;IACI,yBAAyB;IACzB,gCAAgC;QAC5B,YAAY;AACpB;;CAEC;IACG,8BAA8B;IAC9B,gCAAgC;AACpC;;;AAGA;CACC,YAAY;AACb;AACA;CACC,iBAAiB;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;AACrB","sourcesContent":[".navbar-default {\r\n  background: #f0f0f0;\r\n  background: -moz-linear-gradient(top, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);\r\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(255,255,255,1)), color-stop(100%,rgba(240,240,240,1)));\r\n  background: -webkit-linear-gradient(top, rgba(255,255,255,1) 0%,rgba(240,240,240,1) 100%);\r\n  background: -o-linear-gradient(top, rgba(255,255,255,1) 0%,rgba(240,240,240,1) 100%);\r\n  background: -ms-linear-gradient(top, rgba(255,255,255,1) 0%,rgba(240,240,240,1) 100%);\r\n  background: linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(240,240,240,1) 100%);\r\n\r\n  -moz-box-shadow: 0 4px 7px -5px #777;\r\n  -webkit-box-shadow: 0 4px 7px -5px #777;\r\n  box-shadow: 0 4px 7px -5px #777;\r\n  color: #98a6ad !important;\r\n}\r\n.topbar .topbar-left {\r\n  -moz-box-shadow: 0 4px 7px -5px #777;\r\n  -webkit-box-shadow: 0 4px 7px -5px #777;\r\n  box-shadow: 0 4px 7px -5px #777;\r\n  \t    background-color: #FFFFFF !important;\r\n\t    background-image: url(../images/line-poncho.png) !important;\r\n    background-size: auto 3px !important;\r\n    background-repeat: no-repeat !important;\r\n    background-position: right bottom !important;\r\n    padding: 10px 0 0 0 !important;\r\n}\r\n\r\n.button-menu-mobile {\r\n    background-color: #000000;\r\n    border: 1px solid #000000;  \r\n}\r\n.button-menu-mobile:hover {\r\n    background-color: #4f4f4f;\r\n    border: 1px solid #4f4f4f;  \r\n}\r\n.navbar-default .right-menu-item{\r\n  color: #000;\r\n}\r\n.app-search .form-control, .app-search .form-control:focus {\r\n  border: 1px solid rgba(212, 212, 212, 1);\r\n  color: #000000 !important;\r\n  background: #ffffff;\r\n}\r\n.app-search a {\r\n  color: rgba(80, 80, 80, 0.7);\r\n}\r\n\r\n.logo img {\r\n      margin-top: 2px !important;\r\n      width: 169px;\r\n    \theight: auto;\r\n}\r\n\r\n.logo i {\r\n        margin-top: 4px !important;\r\n}\r\n.user-box .dropdown-menu {\r\n\tleft: auto !important;\r\n    right: 0 !important;\r\n }\r\n\r\n\r\n\r\n.app-search .form-control::placeholder {\r\n  color: #98a6ad !important;\r\n}\r\n.app-search .form-control::-webkit-input-placeholder {\r\n  color: #98a6ad !important;\r\n}\r\n.app-search .form-control::-moz-placeholder {\r\n  color: #98a6ad !important;\r\n}\r\n.app-search .form-control:-ms-input-placeholder {\r\n  color: #98a6ad !important;\r\n}\r\n.app-search .form-control:-moz-placeholder {\r\n  color: #98a6ad !important;\r\n}\r\n.gmaps, .gmaps-panaroma {\r\n  height: 700px;\r\n}\r\n\r\n.nav-tabs > li > a {\r\n    font-size: 12px;\r\n}\r\n.content-tabs-ypf{\r\n    border-top: none !important;\r\n    border-top-left-radius: 0 !important;\r\n    border-top-right-radius: 0 !important;\r\n\r\n}\r\n.badge {\r\n    font-size: 12px;\r\n}\r\n\r\n.form-control-static {\r\n  color: #015192;\r\n  font-weight: 500;\r\n  font-size: 13px;\r\n}\r\n\r\nlabel {\r\n  font-size: 13px;\r\n}\r\n\r\n.badge-modal {\r\n  position: absolute;\r\n  right: 46px;\r\n  top: 6px;\r\n}\r\n.navbar-default{\r\n\t    background-color: #FFFFFF !important;\r\n\t    background-image: url(../images/line-poncho.png) !important;\r\n\t    background-size: 100% 3px !important;\r\n\t    background-repeat: no-repeat !important;\r\n\t    background-position: bottom !important;\r\n}\r\n\r\n.enlarged #wrapper .left.side-menu #sidebar-menu ul > li {\r\n    white-space: normal !important;\r\n}\r\n/* CUSTOM IMG SIMULADOR */\r\n\r\n.container-img{\r\n  background-color:#FFFFFF;\r\n  width: 100%;\r\n  height: 450px;\r\n  overflow: auto;\r\n  position: relative;\r\n}\r\n\r\n#img-mapa {\r\n  -webkit-transition: all .2s ease-in-out;\r\n  -moz-transition: all .2s ease-in-out;\r\n  -o-transition: all .2s ease-in-out;\r\n  -ms-transition: all .2s ease-in-out;\r\n  /*position: absolute;*/\r\n  top: 0;\r\n  left: 0;\r\n  transform: scale(1);\r\n  transform-origin: 0 0;\r\n}\r\n\r\n.container-plano {\r\n    width: 100%; \r\n  \theight: 450px;\r\n  \toverflow-y: scroll;\r\n    overflow-x: scroll;  \t\r\n}\r\n\r\n.masthead{\r\n  background-color: #000000 !important;\r\n}\r\n.links{\r\n  position: absolute;\r\n  cursor: pointer;\r\n  font-size: 10px;\r\n  text-align: center;\r\n  color: #FFFFFF;\r\n  width: 75px;\r\n  height: 75px;\r\n  border-radius: 50%;\r\n  background-color: rgba(255, 0, 0, 0.3);\r\n  left: 240px;\r\n  top: 126px;\r\n}\r\n.links.focused:after{\r\n  position: absolute;\r\n  top: -5px;\r\n  height: calc(100% + 10px);\r\n  left: -5px;\r\n  width: calc(100% + 10px);\r\n  /*border: 2px solid rgba(120, 0, 0, 0.7);*/\r\n  content: '';\r\n  display: block;\r\n  border-radius: 50%;\r\n}\r\n.act{\r\n  background-color: rgba(255, 0, 0, 0.7);\r\n}\r\n.shadow-prueba{\r\n\t  box-shadow: 3px 3px 3px #333;\r\n\t  border: 1px solid red;\r\n}\r\n#link-1{\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 50%;\r\n  background-color: rgba(255, 0, 0, 0.7);\r\n  left: 262px;\r\n  top: 152px;\r\n}\r\n#link-2{\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 50%;\r\n  background-color: rgba(127, 191, 63, 0.7);\r\n  left: 163px;\r\n  top: 150px;\r\n}\r\n.nav-zoom{\r\n  background: #f0f0f0;\r\n  background: -moz-linear-gradient(top, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);\r\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(255,255,255,1)), color-stop(100%,rgba(240,240,240,1)));\r\n  background: -webkit-linear-gradient(top, rgba(255,255,255,1) 0%,rgba(240,240,240,1) 100%);\r\n  background: -o-linear-gradient(top, rgba(255,255,255,1) 0%,rgba(240,240,240,1) 100%);\r\n  background: -ms-linear-gradient(top, rgba(255,255,255,1) 0%,rgba(240,240,240,1) 100%);\r\n  background: linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(240,240,240,1) 100%);\r\n  color: #000000;\r\n  width: 100%;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n.inner-zoom{\r\n  width: 600px;\r\n\r\n}\r\n\r\n.logo-most{\r\n  max-width: 270px;\r\n}\r\n.logo-ypf{\r\n  max-width: 150px;\r\n}\r\n.cover-container{\r\n  position: relative;\r\n  padding-left: 0rem!important;\r\n  padding-right: 0rem!important;\r\n  padding-bottom: 0rem!important;\r\n  padding-top: 0!important;\r\n}\r\n\r\n.modal-content{\r\n  color: #0b2e13;\r\n}\r\n\r\n.modal table{\r\n  font-size: 12px !important;\r\n}\r\n.f-10{\r\n  font-size: 10px !important;\r\n}\r\n.f-11{\r\n  font-size: 11px !important;\r\n}\r\n.f-12{\r\n  font-size: 12px !important;\r\n}\r\n.f-13{\r\n  font-size: 13px !important;\r\n}\r\n.f-14{\r\n  font-size: 14px !important;\r\n}\r\n.f-16{\r\n  font-size: 16px !important;\r\n}\r\n\r\n.modal-lg {\r\n  max-width: 1024px !important;\r\n}\r\n\r\n#color-link1{\r\n  color: transparent !important;\r\n}\r\n\r\n.margin-top-10{\r\n\tmargin-top:10px !important;\r\n}\r\n\r\n#datatable_filter{\r\n  float: right !important;\r\n}\r\n#datatable_filter label{\r\n  margin-bottom: 0;\r\n}\r\n.dataTables_length {\r\n  margin-top: 15px;\r\n  margin-bottom: 0;\r\n  padding-bottom: 0px;\r\n}\r\n\r\n.dataTables_length label{\r\n  margin-bottom: 0;\r\n}\r\n.pagination{\r\n  float: right;\r\n}\r\n\r\n.txt-header-modal{\r\n  position: absolute;\r\n  right: 15px;\r\n  font-size: 12px;\r\n  top: 20px;\r\n  text-align: right;\r\n}\r\n\r\n.bg-light {\r\n  background-color: #f3f3f3!important;\r\n}\r\n\r\n.tabs-bordered .nav-item .nav-link.active {\r\n  border-bottom: 3px solid #78c350 !important;\r\n  margin-bottom: -1px;\r\n  color: #348cd4;\r\n}\r\n.card-heading {\r\n  padding: 10px 20px;\r\n}\r\n\r\n.footer {\r\n    padding: 7px 10px 6px;\r\n        position: fixed;\r\n}\r\n#wrapper {\r\n    overflow: initial !important;\r\n}\r\n.table {\r\n    font-size: 13px;\r\n}\r\n\r\n.icono{\r\n    font-size: 17px;\r\n}\r\n\r\n.page-title-box .page-title {\r\n    margin-bottom: 5px;\r\n    float: initial;\r\n    font-size: 20px;\r\n}\r\n\r\n.page-title-box .breadcrumb {\r\n    float: inherit;\r\n}\r\n.btn-custom {\r\n    border: 1px solid #348cd4 !important;\r\n}\r\n.btn-custom:hover, .btn-custom:focus, .btn-custom:active, .btn-custom.active, .btn-custom.focus, .btn-custom:active, .btn-custom:focus, .btn-custom:hover, .open > .dropdown-toggle.btn-custom {\r\n    border: 1px solid #348cd4 !important;\r\n}\r\n\r\n.col-acciones{\r\n\twidth: 110px !important;\r\n\ttext-align: center;\r\n}\r\n\r\ntd a i{\r\n\tfont-size: 18px !important;\r\n}\r\n\r\n.tab-content {\r\n    padding: 12px 12px 12px 12px;\r\n    border-bottom: 1px solid #dee2e6;\r\n    border-left: 1px solid #dee2e6;\r\n    border-right: 1px solid #dee2e6;\r\n    margin-bottom: 17px;\r\n}\r\n.obligatorio{\r\n\tcolor:#ff0000;\r\n\tfont-size: 12px;\r\n}\r\n.text-obligatorio{\r\n\tcolor:#ff0000 !important;\r\n}\r\n\r\n.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {\r\n    color: #ffffff !important;\r\n}\r\n.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {\r\n    background-color: #358cd4 !important;\r\n}\r\n.nav-tabs .nav-link {\r\n    background-color: #f3f3f3 !important;\r\n}\r\n\r\n#modalCrearPregunta{\r\n\tbackground-color: rgba(0, 0, 0, 0.7) !important;\r\n\tpadding-right: 30px !important;\r\n}\r\n\r\n#modalCrearDominio{\r\n\tbackground-color: rgba(0, 0, 0, 0.7) !important;\r\n}\r\n\r\n.cursor{\r\n\tcursor: pointer !important;\r\n}\r\n\r\n.disabledbutton {\r\n\t    pointer-events: none;\r\n\t    opacity: 0.4;\r\n}\r\n\r\n.accordion-poncho{\r\n\tbackground: #ffffff !important;\r\n    border-radius: 20px !important;\r\n        border: 1px solid #e2e2e2;\r\n       \r\n}\r\n\r\n.collapse {\r\n    border-bottom: 0 !important;\r\n}\r\n\r\n.headingAccordion{\r\n    padding: 5px 5px 2px 5px;\r\n    background-color: #348CD4;\r\n    border-top-right-radius: 15px !important;\r\n    border-top-left-radius: 15px !important;\r\n}\r\n.headingAccordion button{\r\nmargin-top: -34px;\r\n\r\n}\r\n.bg-amarillo{\r\n\t background-color: #eed057 !important;\r\n}\r\n.bg-contratista {\r\n  background-color: #00a5af !important;\r\n}\r\n.page-title-box {\r\n    padding: 25px 20px 0px 25px;\r\n}\r\n.card{\r\n\t    border-radius: 1.25rem;\r\n}\r\n\r\n#map_dashboard{\r\n\t-webkit-box-shadow: 0px 0px 13px 0px rgba(0,0,0,0.29);\r\n\t-moz-box-shadow: 0px 0px 13px 0px rgba(0,0,0,0.29);\r\n\tbox-shadow: 0px 0px 13px 0px rgba(0,0,0,0.29);\r\n}\r\n.table-responsive {\r\n\tborder-top:1px solid #cecece;\r\n}\r\n\r\n#datosintalacionestable_length{\r\n    position: absolute !important;\r\n    right: 7px !important;\r\n    top: -11px !important;\r\n}\r\n\r\n\r\n#datosintalacionestable_wrapper > div:first-child {\r\n    background-color: #f3f3f3;\r\n    border-bottom: 1px #cecece solid;\r\n        height: 39px;\r\n}\r\n\r\n #datosintalacionestable {\r\n    margin-bottom: -5px !important;\r\n    border-bottom: 1px solid #cecece;\r\n}\r\n\r\n\r\n#datosintalacionestable_length{\r\n\tfloat: right;\r\n}\r\n#datosintalacionestable_wrapper{\r\n\tposition:relative;\r\n}\r\n\r\n#datosintalacionestable_info{\r\n    padding-top: 4px;\r\n    white-space: normal;\r\n    font-size: 12px;\r\n    padding-right: 49px;\r\n    line-height: 14px;\r\n    color: #008fcf;\r\n}\r\n\r\n.nav-second-level.nav > li > a {\r\n    padding-left: 46px !important;\r\n    line-height: 15px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
